// ─── Template : écran « À VENIR » (Core) ──────────────────────────
// Écran vide préparé pour une fonction pas encore migrée/implémentée :
// emoji + titre + destination + PÉRIMÈTRE prévu (liste des fonctions).
//   <AVenir emoji="💬" titre="Messagerie" destination="Core"
//           fonctions={[…]} onRetour={…} />
// `ContenuAVenir` : le corps seul, à poser dans une Feuille ou une page.
import React, { useMemo } from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';
import { useT } from '../i18n/LangueContext';
import PageHeader from './PageHeader';
import GesteRetourEcran from '../nav/GesteRetourEcran';

export function ContenuAVenir({ emoji, titre, destination, fonctions = [], message }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <View style={s.corps}>
      <Text style={s.emoji}>{emoji}</Text>
      <Text style={s.titre}>{message || t('avenir.bientot', { nom: titre })}</Text>
      <Text style={s.sous}>{t('avenir.migration')}</Text>
      {!!destination && (
        <View style={s.destChip}><Text style={s.destTxt}>{t('avenir.destination')} : {destination}</Text></View>
      )}
      {fonctions.length > 0 && (
        <View style={s.carte}>
          <Text style={s.carteTitre}>{t('avenir.perimetre')}</Text>
          {fonctions.map((f, i) => (
            <View key={i} style={s.ligne}>
              <Text style={s.puce}>•</Text>
              <Text style={s.fonc}>{f}</Text>
            </View>
          ))}
        </View>
      )}
    </View>
  );
}

export default function AVenir({ emoji, titre, destination, fonctions, message, onRetour }) {
  const UI = useUI();
  return (
    // Balayage depuis le bord GAUCHE = retour (principe de navigation app-wide).
    <GesteRetourEcran actif={!!onRetour} onRetour={onRetour}>
      <View style={{ flex: 1, backgroundColor: UI.bg }}>
        <PageHeader titre={titre} iconeTitre={emoji} onRetour={onRetour} />
        <ScrollView>
          <ContenuAVenir emoji={emoji} titre={titre} destination={destination} fonctions={fonctions} message={message} />
        </ScrollView>
      </View>
    </GesteRetourEcran>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  corps: { alignItems: 'center', padding: 22 },
  emoji: { fontSize: 40, marginTop: 8 },
  titre: { fontSize: 15.5, fontWeight: '800', color: UI.ink, marginTop: 10, textAlign: 'center' },
  sous:  { fontSize: 12.5, color: UI.muted, marginTop: 4, textAlign: 'center' },
  destChip: { marginTop: 10, borderWidth: 0.5, borderColor: UI.border, borderRadius: 999, paddingVertical: 4, paddingHorizontal: 12 },
  destTxt: { fontSize: 11.5, color: UI.accent, fontWeight: '700' },
  carte: { alignSelf: 'stretch', backgroundColor: UI.card, borderRadius: 13, borderWidth: 0.5, borderColor: UI.border, padding: 14, marginTop: 16 },
  carteTitre: { fontSize: 12, fontWeight: '800', color: UI.muted, marginBottom: 8, letterSpacing: 0.3 },
  ligne: { flexDirection: 'row', gap: 8, marginBottom: 6 },
  puce: { color: UI.accent, fontWeight: '800' },
  fonc: { flex: 1, fontSize: 13, color: UI.ink, lineHeight: 18 },
});
